import styled, { css } from 'styled-components';
import { getColor, horizontalOverflowItem, horizontalOverflowParent } from "core/utils";

export const Wrapper = styled.section`
	padding: 16px 0;
`;

export const Card = styled.a`
	${horizontalOverflowItem}
	cursor: pointer;
	min-height: 220px;

	figure {
		border-radius: 8px;
	}
`;

export const CardDate = styled.div`
	color: ${getColor('dustyGray')};
	margin-top: 4px;
	margin-bottom: 5px;
	letter-spacing: 0.2px;
	font-size: 14px;
	line-height: 18px;
`;

export const CardsWrapper = styled.div`
	overflow: hidden;
	position: relative;

	@media (max-width: ${props => props.wrapAt || 1023}px) {
		width: 100vw;
		margin-left: -25px;
	}

	${props => !props.doneScrollingX && css`
		&:before {
			@media (max-width: ${props => props.wrapAt || 1023}px) {
				content: '';
				width: 120px;
				height: 100%;
				top: 0;
				right: 0;
				position: absolute;
				z-index: 2;
				background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.01), rgba(255, 255, 255, 1));
			}

			@media (max-width: 767px) {
				width: 60px;
			}
		}
	`}
`;

export const Title = styled.h4`
	color: ${getColor("gray")};
	margin-top: 6px;
	margin-bottom: 0px;
	font-size: 16px;
	line-height: 17px;
	letter-spacing: 0.2px;
	font-weight: 600;
`;

export const Cards = styled.div`
	margin-top: 24px;
	${horizontalOverflowParent}
`;
